import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * Composition-friendly Card — header (title + subtitle + actions) + body.
 * Mirrors the DS .card class from kit.css :
 *   <div class="card"><header>…</header><div class="body">…</div></div>
 */
export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  padded?: boolean; // default true — wraps children in .body
}

export function Card({
  title, subtitle, actions, padded = true, className, children, ...rest
}: CardProps) {
  return (
    <div className={cn('card', className)} {...rest}>
      {(title || subtitle || actions) && (
        <header>
          {title && <h3>{title}</h3>}
          {subtitle && <span className="s">{subtitle}</span>}
          {actions && (
            <>
              <div className="sp" />
              {actions}
            </>
          )}
        </header>
      )}
      {padded ? <div className="body">{children}</div> : children}
    </div>
  );
}
